type SentryModule = typeof import('@sentry/react');

const isProduction = import.meta.env.VITE_ENVIRONMENT === 'production';

const SENTRY_DSN = 'https://5a7d5020cbc34f8e89b975eca79a30fc@o4504777243885568.ingest.sentry.io/4504777251553280';

let sentryLoadPromise: Promise<SentryModule | null> | null = null;

/** Lazy-load SDK into its own chunk — keeps `@sentry/*` out of the sync entry bundle. */
const loadSentry = (): Promise<SentryModule | null> => {
  if (!isProduction) return Promise.resolve(null);
  if (!sentryLoadPromise) {
    sentryLoadPromise = Promise.all([import('@sentry/react'), import('@sentry/tracing')])
      .then(([Sentry, { BrowserTracing }]) => {
        Sentry.init({
          dsn: SENTRY_DSN,
          integrations: [new BrowserTracing()],
        });
        return Sentry;
      })
      .catch(() => null);
  }
  return sentryLoadPromise;
};

const initSentry = (): void => {
  if (!isProduction) {
    // eslint-disable-next-line no-console
    console.warn('Sentry not initialized');
    return;
  }
  void loadSentry();
};

type CaptureContext = Parameters<SentryModule['captureException']>[1];

/** Safe from any chunk; loads Sentry on first error if init has not finished yet. */
export const captureException = (error: unknown, captureContext?: CaptureContext): void => {
  void loadSentry().then(Sentry => {
    Sentry?.captureException(error, captureContext);
  });
};

export default initSentry;
